import { TYPE_OF_COUNT } from "@/constants/constants";
import formatCurrency from "@/helper/formatCurrency";

function getSum(array) {
	return array.reduce((acc, item) => (acc += item[TYPE_OF_COUNT.AMOUNT] || item[TYPE_OF_COUNT.TOTAL]), 0);
}
export default function(list) {
	const positiveList = list.filter(item => item[TYPE_OF_COUNT.CATEGORY] === TYPE_OF_COUNT.CREDIT
			|| item[TYPE_OF_COUNT.TYPE] === TYPE_OF_COUNT.BONUS
			|| item[TYPE_OF_COUNT.TYPE] === TYPE_OF_COUNT.SALARY
	);
	const negativeList = list.filter(item => item.category === TYPE_OF_COUNT.DEDUCTION
			|| item[TYPE_OF_COUNT.TYPE] === TYPE_OF_COUNT.CHARGE
	);
	const positiveListAmount = getSum(positiveList);
	const negativeListAmount = getSum(negativeList);

	return formatCurrency(positiveListAmount - negativeListAmount);
}
